import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { Select } from '@mantine/core'
import { generateTimeObjects, manipulateTimeObject } from './timeModel'

const StyledTimeRange = styled.div`
  display: flex;
  padding: 5px 0;
  position: relative;
  .component {
    display: flex;
    padding: 5px;
    align-items: center;
    position: relative;
  }

  .component .label {
    padding-right: 10px;
  }

  .error {
    color: red;
    position: absolute;
    font-size: 13px;
    bottom: -10px;
  }
`

const TimeRange = (props) => {
  const [timeModel, setTimeModel] = useState()
  const {
    startMoment,
    endMoment,
    className,
    onClick,
    onChange,
    onStartTimeClick,
    onStartTimeChange,
    onEndTimeClick,
    onEndTimeChange,
    children,
    use24Hours,
    startLabel,
    endLabel,
    showErrors,
    minuteIncrement,
    sameIsValid,
    equalTimeError,
    endTimeError,
  } = props
  const buildModel = (curProps) => {
    const tmpModel = generateTimeObjects(curProps)
    setTimeModel(tmpModel)
  }

  const generateTimeObjectsByTime = (curProps) => {
    return generateTimeObjects({
      ...curProps,

      minuteIncrement,
      sameIsValid,
      equalTimeError,
      endTimeError,
    })
  }

  useEffect(() => {
    buildModel({
      startMoment,
      endMoment,
      minuteIncrement,
      sameIsValid,
      equalTimeError,
      endTimeError,
    })
  }, [startMoment, endMoment])

  const changeTime = (value, target) => {
    let sValue = startMoment
    let eValue = endMoment
    if (target === 'start' && onStartTimeChange) {
      sValue = manipulateTimeObject(sValue, value)
      const tmpObj = generateTimeObjectsByTime({
        startMoment: sValue,
        endMoment,
      })
      onStartTimeChange({
        startTime: sValue,
        error: tmpObj.error,
      })
    } else if (target === 'end' && onEndTimeChange) {
      eValue = manipulateTimeObject(eValue, value)
      const tmpObj = generateTimeObjectsByTime({
        startMoment,
        endMoment: eValue,
      })
      onEndTimeChange({
        endTime: eValue,
        error: tmpObj.error,
      })
    }

    if (onChange) {
      onChange({
        startTime: sValue,
        endTime: eValue,
      })
    }
  }

  const componentClicked = (target) => {
    if (onClick) {
      onClick()
    }

    if (target === 'start' && onStartTimeClick) {
      onStartTimeClick()
    } else if (target === 'end' && onEndTimeClick) {
      onEndTimeClick()
    }
  }

  // const getOption = (value) => {
  //   if (value) {
  //     return {
  //       label: value.replace(/(\d{2})(\d{2})/g, '$1:$2'),
  //       value,
  //     }
  //   }
  //   return null
  // }

  const render = () => {
    const calendar = React.Children.toArray(children)

    return (
      timeModel && (
        <StyledTimeRange className={className}>
          <div id="start-component" className="component">
            {startLabel && <span className="label">{startLabel}</span>}
            {calendar[0] && <span className="component">{calendar[0]}</span>}

            <Select
              value={timeModel.startTimeValue}
              style={{ width: '100px' }}
              maxDropdownHeight={170}
              data={
                timeModel.startTimeIncrement &&
                timeModel.startTimeIncrement.map((resp) => ({
                  value: resp.value,
                  label: use24Hours
                    ? `${resp.HH}:${resp.MM}`
                    : `${resp.hh}:${resp.mm} ${resp.period}`,
                }))
              }
              onChange={(e) => changeTime(e, 'start')}
              onClick={() => componentClicked('start')}
              placeholder="请选择时间"
            />
          </div>
          <div id="end-component" className="component">
            {endLabel && <span className="label">{endLabel}</span>}
            {calendar[1] && <span className="component">{calendar[1]}</span>}

            <Select
              value={timeModel.endTimeValue}
              style={{ width: '100px' }}
              maxDropdownHeight={170}
              data={
                timeModel.endTimeIncrement &&
                timeModel.endTimeIncrement.map((resp) => ({
                  value: resp.value,
                  label: use24Hours
                    ? `${resp.HH}:${resp.MM}`
                    : `${resp.hh}:${resp.mm} ${resp.period}`,
                }))
              }
              onChange={(e) => changeTime(e, 'end')}
              onClick={() => componentClicked('end')}
              placeholder="请选择时间"
            />
          </div>
          {showErrors && timeModel.error && (
            <div className="error">{timeModel.error}</div>
          )}
        </StyledTimeRange>
      )
    )
  }
  return render()
}

TimeRange.defaultProps = {
  use24Hours: false,
  useCalendarChildren: false,
  sameIsValid: true,
  calendarChildren: 0,
  minuteIncrement: 30,
  startLabel: '',
  endLabel: '到',
  showErrors: true,
  repositionTimes: false,
  equalTimeError: '开始时间不能和结束时间相同',
  endTimeError: '结束时间不能早于开始时间',
}

TimeRange.propTypes = {
  use24Hours: PropTypes.bool,
  startLabel: PropTypes.string,
  endLabel: PropTypes.string,
  startMoment: PropTypes.string.isRequired,
  endMoment: PropTypes.string.isRequired,
  minuteIncrement: PropTypes.oneOf([1, 2, 5, 10, 15, 20, 30, 60]),
  sameIsValid: PropTypes.bool,
  className: PropTypes.string,
  onClick: PropTypes.func,
  onChange: PropTypes.func,
  showErrors: PropTypes.bool,
  equalTimeError: PropTypes.string,
  endTimeError: PropTypes.string,
  onStartTimeClick: PropTypes.func,
  onStartTimeChange: PropTypes.func,
  onEndTimeClick: PropTypes.func,
  onEndTimeChange: PropTypes.func,
}

export default TimeRange
